import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

export default props => {
    const { money, locale } = props
    const global = useSelector(state => state.global)

    const { config } = global

    const clientId = locale === 'en-GB' ? config?.klarna?.clientIdGB : config?.klarna?.clientId

    useEffect(() => {
        let klarnaScript = document.getElementById('klarna-message-script')
        const head = document.getElementsByTagName('head')[0]
        if (!klarnaScript) {
            const script = document.createElement('script')
            script.id = 'klarna-message-script'
            script.type = 'text/javascript'
            script.src = "https://js.klarna.com/web-sdk/v1/klarna.js"
            script.setAttribute('data-client-id', clientId)
            script.async = true
            head.appendChild(script)
        }
    }, [])

    return <klarna-placement
        data-key="credit-promotion-badge"
        data-locale={locale || 'en-US'}
        data-purchase-amount={(Number(money?.amount) * 100).toFixed(0)}
  ></klarna-placement>

}